import { useMutation } from '@tanstack/react-query';
import { enquiryApi } from './enquiry.api';
import {
  generalEnquiryApi,
  type GeneralEnquiryCreateInput,
} from '@/features/general-enquiry/api/general-enquiry.api';
import type { RecordEnquiryRevealPayload } from '@/types/enquiry';

export const useRecordEnquiryReveal = () => {
  return useMutation({
    mutationFn: (payload: RecordEnquiryRevealPayload) => enquiryApi.recordReveal(payload),
  });
};

export const useCreatePropertyEnquiry = () => {
  return useMutation({
    mutationFn: (input: GeneralEnquiryCreateInput) => generalEnquiryApi.create(input),
  });
};

export { useVerifyRecaptcha } from '@/features/general-enquiry/api/general-enquiry.mutations';
